import { configureStore } from '@reduxjs/toolkit';
import userSlice from './slice/userSlice';

export const store = configureStore({
    reducer: { userSlice },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
